import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthContext } from '../../context/AuthContext';

const useUserPokemons = () => {
  const [userPokemons, setUserPokemons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user, token } = useAuthContext();

  useEffect(() => {
    const fetchUserPokemons = async () => {
      setIsLoading(true);
      try {
        if (!user || !token) {
          setIsLoading(false);
          return;
        }

        const response = await axios.get(`https://api.poketask.fr/api/user/${user.id}/user_pokemons`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserPokemons(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des Pokémon :', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserPokemons();
  }, [user, token]);

  return { userPokemons, isLoading };
};

export default useUserPokemons;